import { ApiRequestMeta, ParsedApiError, WithApiRequestMeta } from "./types";

export const isParsedApiError = (value: unknown): value is ParsedApiError =>
  !!(
    value &&
    typeof value === "object" &&
    (value as { __parsedApiError?: unknown }).__parsedApiError === true
  );

/** Checks if a given error has a specific code. */
export const apiErrorHasCode = (
  error: ParsedApiError,
  ...codes: string[]
): boolean =>
  error.type === "http" && error.codes.some((code) => codes.includes(code));

/** Gets the first error message for a given field. */
export const getApiFieldError = (
  error: ParsedApiError,
  field: string
): string | undefined =>
  error.type === "http" ? error.fieldErrors[field]?.[0] : undefined;

/** Reads `meta` from RTK Query's query or mutation. */
export const getApiRequestMeta = (
  originalArgs: unknown
): ApiRequestMeta | undefined =>
  (originalArgs as WithApiRequestMeta | null | undefined)?.meta;

/** Removes `meta` from args before cache-key serialization / HTTP params. */
export const omitApiRequestMeta = <T>(queryArgs: T): T => {
  if (!queryArgs || typeof queryArgs !== "object" || Array.isArray(queryArgs)) {
    return queryArgs;
  }

  if (!("meta" in queryArgs)) {
    return queryArgs;
  }

  const { meta: ignoredMeta, ...rest } = queryArgs as T & {
    meta?: ApiRequestMeta;
  };

  return rest as T;
};
